import React from "react";
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import { useStyles } from "./notificationCentr.styles";
import { NotificatioResponse } from "./redux/notificationCenterSlice.types";
import { TextConstants } from "constants/TextConstants";

interface TabsSectionProps {
  activeTab: number;
  notifications: NotificatioResponse[];
  onTabChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  onMarkAllAsRead: () => void;
}

const TabsSection: React.FC<TabsSectionProps> = ({
  activeTab,
  notifications,
  onTabChange,
  onMarkAllAsRead,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.stickyTabs}
      >
        <Tab label={TextConstants.UNREAD} />
        <Tab label={TextConstants.READ} />
      </Tabs>
      <Box display="flex" justifyContent="flex-end" padding={1}>
        {activeTab === 0 && notifications.filter((notification) => !notification.ack).length  > 0 && (
          <Typography
            className={classes.markAllAsRead}
            onClick={onMarkAllAsRead}
          >
            {TextConstants.MARK_ALL_AS_READ}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TabsSection;
